import classnames from 'classnames';
import PropTypes from 'prop-types';
import { markdownToRawMarkup } from '../../utils/html-utils';
import { ContentTitle } from '../typography/Heading';
import ThemeContainer from '../theme-container/ThemeContainer';
import styles from './banner-media.module.less';
import { getBlockComponentForContent } from '../../utils/cms-utils';

const BannerMedia = ({ title = '', text = '', link = null, theme, children = null, content }) => {
    const textAsHtml = markdownToRawMarkup(text);
    const bannerContainer = classnames(
        styles.bannerContainer,
        theme?.style ? styles[`container-style-${theme.style}`] : null
    );

    return (
        <ThemeContainer className={styles.themeWrapper}>
            <div className={bannerContainer}>
                <div className={styles.textContainer}>
                    <ContentTitle className={styles.bannerTitle}>{title}</ContentTitle>
                    <div className={styles.textBlock}>
                        <div dangerouslySetInnerHTML={textAsHtml} />
                        {link && <span className={styles.link}>{link}</span>}
                        {content && content.map((data) => getBlockComponentForContent({ data }))}
                    </div>
                </div>
                {children}
            </div>
        </ThemeContainer>
    );
};

BannerMedia.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.node,
    children: PropTypes.node,
};

export default BannerMedia;
